import { Link } from 'react-router-dom'

const cardStyle = {
  display: 'block', padding: 20, background: '#1a1d29',
  border: '1px solid #2a2d3a', borderRadius: 8,
  textDecoration: 'none', color: '#e5e7eb', marginBottom: 12,
}

export default function FirstCampaignStep({ onDone }) {
  return (
    <div>
      <p style={{ color: '#aaa', fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>
        Two ways to launch your first campaign. AI-generated is fastest if you
        already filled in your company URL.
      </p>

      <Link to="/campaigns/ai-create" onClick={onDone} style={cardStyle}>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>
          AI-generated <span style={{ color: '#3b82f6', fontSize: 11 }}>RECOMMENDED</span>
        </div>
        <div style={{ color: '#888', fontSize: 12 }}>Scrape your site → AI writes a 3-step sequence in 30 seconds.</div>
      </Link>

      <Link to="/campaigns/add" onClick={onDone} style={cardStyle}>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>Build manually</div>
        <div style={{ color: '#888', fontSize: 12 }}>Write every subject and body yourself. Full control.</div>
      </Link>
    </div>
  )
}
